import faq from '../../../api/company/faq'

// initial state
const state = {
  faqList: []
}

// getters
const getters = {
  faqList: (state, getters) => {
    let staticState = state.faqList
    if (staticState != null && staticState.length > 0) {
      return staticState
    }
    if (process.browser) {
      return JSON.parse(localStorage.getItem('faqList'))
    } else {
      return []
    }
  }
}

// actions
const actions = {
  getFAQ ({ commit }) {
    return new Promise((resolve, reject) => {
      faq.getFAQ()
        .then(res => {
          commit('setList', res)
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}

// mutations
const mutations = {
  setList (state, res) {
    if (process.browser) {
      localStorage.setItem('faqList', JSON.stringify(res))
    }
    state.faqList = res
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/company/faq.js